import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../Common/Button';
import SubscriptionGoalDrawer from './SubscriptionGoalDrawer';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const getItemStyle = (isDragging, draggableStyle) => ({
	userSelect: 'none',
	lineHeight: 1,
	marginBottom: '8px',
	backgroundColor: 'white',
	border: isDragging ? '2px solid #03a9f4' : '',
	...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
	background: isDraggingOver ? '#eee' : 'white',
	borderRadius: '0.25rem',
	padding: '8px',
});

export default class SubscriptionGoals extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			selectedGroup: null,
			showEditGroupDrawer: false,
		};
	}

	onGoalGroupChange = (goalGroup, event) => {
		const goalGroups = [...this.props.subscription.goalGroups];
		const index = goalGroups.findIndex((g) => g === goalGroup);
		goalGroup.name = event.target.value;
		goalGroups.splice(index, 1, goalGroup);
		this.props.updateSubscription('goalGroups', goalGroups);
	};

	onGoalChange = (goalGroupIndex, goalIndex, event) => {
		const goalGroups = [...this.props.subscription.goalGroups];
		const goalGroup = goalGroups[goalGroupIndex];
		goalGroup.goals[goalIndex][event.target.name] = event.target.value;
		goalGroups.splice(goalGroupIndex, 1, goalGroup);
		this.props.updateSubscription('goalGroups', goalGroups);
	};

	addGoalToGroup = (goalGroupIndex) => {
		const goalGroups = [...this.props.subscription.goalGroups];
		const goalGroup = goalGroups[goalGroupIndex];
		goalGroup.goals.push({
			id: 0,
			name: '',
			isActive: true,
			ordinal: goalGroup.goals.length,
			darkGreenName: '',
			mediumGreenName: '',
			lightGreenName: '',
		});
		goalGroups.splice(goalGroupIndex, 1, goalGroup);
		this.props.updateSubscription('goalGroups', goalGroups);
	};

	addGoalGroup = () => {
		const goalGroups = [...this.props.subscription.goalGroups];
		if (goalGroups.length < this.props.maxNumGoalGroups) {
			goalGroups.push({
				id: 0,
				name: 'New Group',
				isActive: true,
				ordinal: goalGroups.length,
				subscriptionId: this.props.subscription.id,
				goals: [
					{
						id: 0,
						name: '',
						isActive: true,
						ordinal: 0,
						darkGreenName: '',
						mediumGreenName: '',
						lightGreenName: '',
					},
				],
			});
			this.props.updateSubscription('goalGroups', goalGroups);
		}
	};

	onDeleteGoalGroup = (index) => {
		const goalGroups = [...this.props.subscription.goalGroups];
		goalGroups.splice(index, 1);
		goalGroups.forEach((group, i) => { group.ordinal = i; });
		this.props.updateSubscription('goalGroups', goalGroups);
	};

	onEditGoalGroup = (goalGroup) => {
		this.setState({ selectedGroup: goalGroup, showEditGroupDrawer: true });
	};

	onCancelDrawer = () => {
		this.setState({ showEditGroupDrawer: false });
	};

	onDragEnd = (result) => {
		if (!result.destination) return;

		const goalGroups = [...this.props.subscription.goalGroups];
		const [removed] = goalGroups.splice(result.source.index, 1);
		goalGroups.splice(result.destination.index, 0, removed);

		const updateStartIndex = Math.min(result.source.index, result.destination.index);

		for (let i = updateStartIndex; i < goalGroups.length; i++) {
			goalGroups[i].ordinal = i;
		}
		this.props.updateSubscription('goalGroups', goalGroups);
	};

	render() {
		return (
			<div className='row subscription-goals'>
				<div className='col-12 mb-3'>
					<h5 className='fw-bold'>Goals</h5>
				</div>
				<DragDropContext onDragEnd={this.onDragEnd}>
					<Droppable droppableId='droppable'>
						{(provided, snapshot) => (
							<div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)} className='p-3'>
								{this.props.subscription.goalGroups.map((group, groupIndex) => (
									<Draggable key={groupIndex} draggableId={group.ordinal.toString()} index={groupIndex}>
										{(provided, snapshot) => (
											<div
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
												className='p-3 mb-2 border rounded bg-light'>
												<div className='d-flex justify-content-between align-items-center'>
													<span className='fw-semibold'>{group.name}</span>
													<div>
														<Button
															type='button'
															name='deleteGroup'
															bootstrapClass='btn btn-danger btn-sm me-2'
															iconName='trash-alt'
															onClick={() => this.onDeleteGoalGroup(groupIndex)}
														/>
														<Button
															type='button'
															name='editGroup'
															bootstrapClass='btn btn-info btn-sm'
															iconName='pencil-alt'
															onClick={() => this.onEditGoalGroup(group)}
														/>
													</div>
												</div>
											</div>
										)}
									</Draggable>
								))}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
				<hr />
				{this.props.subscription.goalGroups.length < this.props.maxNumGoalGroups && (
					<div className='col-12 mt-3'>
						<Button
							name='goalGroup-add'
							type='button'
							bootstrapClass='btn btn-link text-decoration-none'
							text='Add Goal Group'
							onClick={this.addGoalGroup}
						/>
					</div>
				)}
				{this.state.showEditGroupDrawer && (
					<SubscriptionGoalDrawer
						goalGroup={this.state.selectedGroup}
						onCancel={this.onCancelDrawer}
						onGoalGroupChange={this.onGoalGroupChange}
						onGoalChange={this.onGoalChange}
						addGoalToGroup={this.addGoalToGroup}
					/>
				)}
			</div>
		);
	}
}

SubscriptionGoals.propTypes = {
	subscription: PropTypes.object.isRequired,
	removeGoalGroup: PropTypes.func.isRequired,
	maxNumGoalGroups: PropTypes.number.isRequired,
	updateSubscription: PropTypes.func.isRequired,
};
